import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'
import pageApisFormattedResponses from 'api/ResponseFormats/Reporting/Overview/PageActions'
import { handleStatus500 } from 'api/Utility/HandleStatus500'
import apiWrapper from 'api/Utility/ApiWrapper'

const axiosCommonReq = (extraParams: any = {}) => {
  const params = {
    token: getToken(),
    paramsSerializerConfig: true,
    ...extraParams,
  }

  return AxiosInitializer({
    ...params,
  })
}
const filterBuilderFiltersEndPoints = {
  getPages: () => {
    return axiosCommonReq({ transformResConfig: false }).get('/pages')
  },
}

const { getPages } = filterBuilderFiltersEndPoints

const pageApis = {
  getPages: () => {
    return apiWrapper({
      endPoint: getPages,
      responseFormat: pageApisFormattedResponses.getStaticPageFormattedResponse,
      errorFailureAction: handleStatus500,
    })
  },
}

export default pageApis
